import styled, { css } from 'styled-components';

import { CONTAINER_PADDING } from '@components/blocks';
import { media } from '@theme/media';
import { LETTER_SPACING, typography } from '@theme/font';
import { OFFSET } from '@theme/helpers';

export const Container = styled.div`
  margin: 0 auto ${OFFSET.L};
`;

export const Title = styled.div`
  ${typography({ spacing: LETTER_SPACING.M })};
  text-transform: uppercase;
  text-align: center;
  margin-top: ${CONTAINER_PADDING * 3}px;
`;

export const ArtworksContainer = styled.div`
  margin: 0 ${OFFSET.M};
  padding-top: ${OFFSET.S};
  display: grid;
  grid-template-columns: 1fr 1fr;

  ${media.mobile} {
    grid-template-columns: 1fr 1fr 1fr;
  }

  ${media.tablet} {
    padding: ${OFFSET.S} ${OFFSET.M} 0;
  }
`;

export const imageStyles = css`
  height: calc(50vw - 30px);
  width: 100%;

  ${media.tablet} {
    padding: ${OFFSET.S};
    height: calc(33.333vw - 40px - 15px);
  }
`;
